module.exports = __webpack_public_path__ + "static/media/Citein-min.c56ee249.png";